// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__3TkCG","logo":"MainNavigation_logo__-GXGm","nav":"MainNavigation_nav__33MUB","active":"MainNavigation_active__3uxX2"};